import { STATUSES, makeListState } from 'app/utils/redux';

import * as t from './types';

const initialState = {
  comments: makeListState(),
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${t.FETCH_COMMENTS}_SUCCESS`:
      return {
        ...state,
        comments: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          list: action.payload.result.items,
        },
      };
    case `${t.POST_COMMENT}_SUCCESS`:
      return {
        ...state,
        comments: {
          ...state.comments,
          list: [action.payload.result].concat(state.comments.list),
        },
      };
    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/events/annualReport/reducer.js